import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-router-dom';
import BreadCrumbItem, { BreadcrumbsItemProps } from './breadcrumbs-item';
import { BreadcrumbsSC } from './breadcrumbs.styled';

interface BreadcrumbsProps {
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactElement<BreadcrumbsItemProps> | React.ReactElement<BreadcrumbsItemProps>[];
}

const Breadcrumbs = ({ children, className, style }: BreadcrumbsProps) => {
  const childrenCount = React.Children.count(children) - 1;

  return (
    <BreadcrumbsSC className={className} style={style}>
      {React.Children.map(children, (child, idx) => {
        const isLinkable = idx < childrenCount;

        return (
          <React.Fragment key={child.props.href}>
            <Link
              to={child.props.href}
              className={classNames(child.props.className, { active: !isLinkable })}
              style={child.props.style}
              onClick={child.props.onClick}
            >
              {child.props.children}
            </Link>
            {isLinkable ? '/' : null}
          </React.Fragment>
        );
      })}
    </BreadcrumbsSC>
  );
};

Breadcrumbs.Item = BreadCrumbItem;

export default Breadcrumbs;
